<template>
  <div>
    <!--VIEW MODE-->

    <div class="row">
      <div class="col-md-12">
        <div v-if="announcement">
          <h5 class="mt-4 text-main">{{ $t("announcement.name") }}</h5>
          <h4 class="pb-2  ">{{ announcement.name | translate }}</h4>

          <h5 class="mt-4 text-main">{{ $t("sector.name") }}</h5>
          <h4 class="pb-2" v-if="announcement.sector">{{ announcement.sector.name | translate }}</h4>
          <h4 class="pb-2" v-else>{{ $t("common.public") }}</h4>

          <h5 class="mt-4 text-main">{{ $t("announcement.date") }}</h5>
          <h4 class="pb-2">{{ announcement.dueDate | date }}</h4>

          <div v-if="announcement.detail">
            <h5 class="mt-4 text-main">{{ $t("announcement.detail") }}</h5>

            <div v-html="translatedDetail"></div>
          </div>
        </div>
      </div>
    </div>
    <!--END: VIEW MODE-->
  </div>

  <!-- form input end -->
</template>

<script>
export default {
  props: ["announcement"],
  computed: {
    translatedDetail() {
      return this.$options.filters.translate(this.announcement.detail);
    },
  },
};
</script>
